export default "__VITE_ASSET__d41f9c6b__"